import poster1 from './../../../assets/images/static/erpDashboard.jpg';
import poster2 from './../../../assets/images/static/loginBg.jpg';
import poster3 from './../../../assets/images/static/signupBg.jpg';

export const videolist = [
  {
    id: 1,
    poster: poster1,
    source: "https://s3.us-west-2.amazonaws.com/videos-eretailpoint.com/eretailVideo.mp4",
    title: "E-Retail Point is a point-of-sale (POS) solution where you can manage all of"
  },
  {
    id: 2,
    poster: poster2,
    source: "https://s3.us-west-2.amazonaws.com/videos-eretailpoint.com/eretailVideo.mp4",
    title: "E-Retail Point is a point-of-sale (POS) solution where you can manage all of"
  },
  {
    id: 3,
    poster: poster3,
    source: "https://s3.us-west-2.amazonaws.com/videos-eretailpoint.com/eretailVideo.mp4",
    title: "E-Retail Point is a point-of-sale (POS) solution where you can manage all of"
  }
]
